<template>
  <Teleport to="body">
    <section
      class="overlay-menu"
      :class="{ open }"
      :aria-hidden="!open"
      @click.self="$emit('close')"
    >
      <div
        class="menu-icon active"
        role="button"
        tabindex="0"
        aria-label="Menü schließen"
        @click="$emit('close')"
        @keydown.enter.prevent="$emit('close')"
        @keydown.space.prevent="$emit('close')"
      >
        <span></span>
      </div>
      <div class="centered">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 columns half text-center">
              <a href="/" class="logo-full heading_space" @click="$emit('close')"
                ><img src="/images/hbg_logo.png" alt=""
              /></a>
            </div>
            <div class="col-sm-12 columns half text-left">
              <ul class="full-nav top20 heading_space">
                <li
                  :key="nav.key"
                  v-for="(nav, index) in navigation"
                  :class="index === 0 ? 'active' : ''"
                >
                  <span>0{{ index + 1 }}.</span>
                  <a :href="'#' + nav.key" class="scroll" @click="$emit('close')">{{ nav.label }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Teleport>
</template>

<script>
export default {
  props: {
    navigation: Array,
    open: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  watch: {
    open: {
      immediate: true,
      handler(isOpen) {
        if (typeof document === 'undefined') return
        document.body.classList.toggle('mobile-menu-open', isOpen)
      }
    }
  },
  beforeUnmount() {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('mobile-menu-open')
    }
  }
}
</script>
